import { useState } from "react";
import axios from "axios";
import { FileUploadIcon } from "../lead-inventory/icons";
import { API_ENDPOINTS } from "@/api/apiEndpoints";
import { apiRequest } from "@/network/apiClient";
import { toast } from "react-toastify";
import Header from "../header";


const getAuthHeaders = () => {
    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;
    return token ? { Authorization: `Bearer ${token}` } : {};
};
const FileUploadComponent = ({docType, title, leadID, onUploadSuccess}) => {

    const [uploadProgress, setUploadProgress] = useState(0);

    const [files, setFiles] = useState({
        loa: null,
        id: null,
        misc: null
    });
    const [uploading, setUploading] = useState({
        loa: false,
        id: false,
        misc: false
    });
    const [message, setMessage] = useState({
        loa: "",
        id: "",
        misc: ""
    });

    const handleFileChange = (docType, e) => {
        e.preventDefault();
        const selectedFiles = Array.from(e.target.files);

        if (selectedFiles.length > 0) {
            setFiles({
                ...files,
                [docType]: selectedFiles
            });
            // Clear previous message
            setMessage({
                ...message,
                [docType]: ""
            });
        }
    };
    const removeFile = (docType, indexToRemove) => {
        if(!files[docType]) return;

        const updatedFiles = files[docType].filter((_, index) => index !== indexToRemove);

        if (updatedFiles.length === 0) {
            // set to null if all files are removed
            setFiles({
                ...files,
                [docType]: null
            });
        } else {
            //update with remaining files
            setFiles({
                ...files,
                [docType]: updatedFiles
            });
        }
    };
    
    const handleUpload = async (docType, e) =>{
        if (e) e.preventDefault();

        if (!files[docType]) return;
        const authHeaders = getAuthHeaders();
        

        setUploadProgress(0);
        // Set uploading state to true and clear message
        setUploading({
            ...uploading,
            [docType]: true
        });

        // Clear message
        setMessage({
            ...message,
            [docType]: ""
        });

        try {
            const formData = new FormData();
            formData.append("lead_id", leadID);

            // Add each file to form data with section 
            files[docType].forEach(file => {
                formData.append(docType, file);
            });
            setUploadProgress(50);
            console.log(formData.get(docType));
            console.log(formData.get('lead_id'));
            
            for (const file of files[docType]) {
            const presignedRes = await axios.post(
                `${import.meta.env.VITE_BASE_URL}/presigned-url`,
                {
                lead_id: leadID,
                doc_type: docType,
                filename: file.name,
                content_type: file.type,
                },
                {
                    headers:{
                        ...authHeaders
                    }
                }
            );

            const { url, key } = presignedRes.data;

            const result = await axios.put(url, file, {
                headers: { "Content-Type": file.type },
                onUploadProgress: (ProgressEvent) => {
                const percentCompleted = Math.round(
                    (ProgressEvent.loaded * 100) / ProgressEvent.total
                );
                setUploadProgress((prev) => ({
                    ...prev,
                    [file.name]: percentCompleted,
                }));
                },
            });

            console.log(`Uploaded ${file.name} successfully - ${key}`);
            console.log(result)
            if(result.status === 200){
                onUploadSuccess();
                toast.success('File Upload Successful')
            }
            }
            
            setMessage({
                ...message,
                [docType]: "File uploaded successfully"
            });

            // Clear the file input after upload
            document.getElementById(`${docType}-input`).value = "";
            // Clear files state
            setFiles({
                ...files,
                [docType]: null
            });

        }catch (error){
            console.error(`Upload error for ${docType}:`, error);
            setMessage({
                ...message,
                [docType]: `Upload failed: ${error.response?.data?.message || error.message}`
            })
            toast.error(error || 'File Upload Failed')
        }finally{
            setUploading({
                ...uploading,
                [docType]: false
            })
        }
    };

    return(
        <div className="p-4 border rounded-lg mb-4 bg-white w-full">
            <h3 className="text-lg font-semibold mb-2">{title}</h3>

            <form onSubmit={(e) => handleUpload(docType, e)}>
                <div className="mb-4">
                    <label 
                    htmlFor={`${docType}-input`}
                    className="block w-full p-4 flex flex-row justify-betwen border-2 border-[#64748B] rounded-lg cursor-pointer hover:bg-[#E2E8F0]">
                        <div className="flex items-center justify-center gap-4">
                            <img src={FileUploadIcon} alt="File Upload Icon" className="w-8 h-8 mx-auto"/> 
                            <span className="flex flex-col">
                                <h2 className="font-bold text-[#1E293B]">Attach File</h2>
                                <h3 className="text-sm text-[#475569]">PDF, JPEG or PNG less than 8 MB</h3>
                            </span>
                        </div>
                    </label>

                    <input 
                    id={`${docType}-input`}
                    type="file"
                    multiple
                    onChange={(e) => handleFileChange(docType, e)}
                    className="hidden"
                    />
                </div>

                {files[docType] && (
                    <div className="mb-4">
                        <ul className="block overflow-hidden overflow-y-auto">
                            {files[docType].map((file, index) => (
                                <li key={index} className="mb-4 p-4 border-[#E2E8F0] bg-[#E2E8F0] rounded-lg flex flex-row gap-3 items-center relative">
                                    <button 
                                        type="button"
                                        onClick={() => removeFile(docType, index)}
                                        className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 p-1 rounded-full hover:bg-gray-200"
                                        title="Remove file"
                                    >
                                        ✕
                                    </button>
                                    <div className="flex flex-row gap-3 items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-10">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                                        </svg>
                                        <span className="flex flex-col gap-2 justify-center">
                                            <p className="font-bold text-base">{file.name.substring(0, file.name.lastIndexOf('.')) || file.name}</p>
                                            <span className="flex-row gap-4 justify-center">
                                                <a className="text-base gap-4">{file.name.substring(file.name.lastIndexOf('.') + 1)}</a>
                                                <a className="text-xs px-4 text-[#94A3B8]">{(file.size / 1024).toFixed(2)} KB</a>
                                            </span>
                                        </span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <button 
                type="submit"
                disabled={uploading[docType]}
                className="w-full bg-[#F7E21E]  hover:text-white font-bold py-2 px-4 rounded-full disabled:opacity-50">
                    {uploading[docType] ? "Uploading..." : `Upload ${title}`}
                </button>

                {uploading[docType] && (
                    <div className="w-full mt-3 bg-gray-200 rounded-full h-2.5">
                        <div
                        className="bg-blue-600 h-2.5 rounded-full"
                        style={{ width: `${uploadProgress}%` }}
                        ></div>
                    </div>
                )}

                {message[docType] && (
                    <div className={`mt-3 p-2 rounded text-sm ${message[docType].includes("failed") ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}>
                        {message[docType]}
                    </div>
                )}
            </form>
        </div>
    )
}

export default FileUploadComponent;